import { Facility } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';

const groupedFacilities: {
  title: string;
  facilities: {
    icon: string;
    name: Facility;
  }[];
}[] = [
  {
    title: '$.facilities.transports.title',
    facilities: [
      { icon: 'car-profile', name: Facility.TAXI_STAND },
      { icon: 'bus', name: Facility.BUS_STOP },
      { icon: 'train', name: Facility.TRAIN_STATION },
      { icon: 'luggage-03', name: Facility.AIRPORT },
      { icon: 'car-front', name: Facility.CARPOOL_PARKING },
      { icon: 'gasoline', name: Facility.FUEL_STATION },
    ],
  },
  {
    title: '$.facilities.activities.title',
    facilities: [
      { icon: 'park', name: Facility.NATURE },
      { icon: 'playground', name: Facility.RECREATION_AREA },
      { icon: 'gym', name: Facility.SPORT },
      { icon: 'bank', name: Facility.MUSEUM },
      { icon: 'wifi', name: Facility.WIFI },
    ],
  },
  {
    title: '$.facilities.shopping.title',
    facilities: [
      { icon: 'shopping-bag-02', name: Facility.MALL },
      { icon: 'shopping-cart-01', name: Facility.SUPERMARKET },
    ],
  },
  {
    title: '$.facilities.restaurant.title',
    facilities: [
      { icon: 'restaurant', name: Facility.RESTAURANT },
      { icon: 'coffee', name: Facility.CAFE },
      { icon: 'hotel', name: Facility.HOTEL },
    ],
  },
];

export default groupedFacilities;
